export const environment = {
  production: false,
  SOCKET_ENDPOINT: 'https://chat.metanoa.ai',
  //SOCKET_ENDPOINT: 'http://3.6.127.105:5000',
  //SOCKET_ENDPOINT: 'http://localhost:5000',
  OT_KEY: '46803104'
};